import React from 'react';
import { CadNextAction } from './types';
import { ActionHandlerContextValue } from '@m43/action-broadcaster';

export type CadNextActionHandlerContextValue = ActionHandlerContextValue<CadNextAction>;

export const ActionBroadcasterContext = React.createContext<
    CadNextActionHandlerContextValue | undefined
>(undefined);
